<div class="header">
  @if (surveyLayoutService.onBackButton) {
    <button
      class="back-button"
      nz-button
      nzType="default"
      nzShape="circle"
      (click)="surveyLayoutService.onBackButton()"
    >
      <span nz-icon [nzType]="'left'"></span>
    </button>
  }

  <div class="logo">
    <img src="/assets/mathema-logo.png" alt="Mathema.me" />
  </div>
</div>

<nz-layout class="survey-body">
  <div class="info-side">
    <math-survey-info />
  </div>

  <div class="content">
    <router-outlet />
  </div>
</nz-layout>
